module.exports = __webpack_public_path__ + "static/media/lander_state_diagram.d500a8b2.jpg";